import React from "react";
import { node, shape, string } from "prop-types";
import defaultClasses from "./message.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import Icon from "../../../../components/Icon";
var Message = props => {
  var {
    children,
    classes: propClasses,
    fieldState
  } = props;
  var {
    asyncError,
    error
  } = fieldState;
  var errorMessage = error || asyncError;
  var classes = mergeClasses(defaultClasses, propClasses);
  var className = errorMessage ? classes.root_error : classes.root;
  return /*#__PURE__*/React.createElement("div", {
    className: "message-container ".concat(className)
  }, errorMessage ? /*#__PURE__*/React.createElement(Icon, {
    name: "icon-error",
    color: "red"
  }) : null, /*#__PURE__*/React.createElement("p", null, errorMessage || children));
};
export default Message;
Message.defaultProps = {
  fieldState: {}
};
Message.propTypes = {
  children: node,
  classes: shape({
    root: string,
    root_error: string
  }),
  fieldState: shape({
    asyncError: string,
    error: string
  })
};